import { cn } from "@/lib/utils";

interface GridPatternProps {
  className?: string;
  /** Espaçamento entre linhas em px. Default 90. */
  gap?: number;
  /** Opacidade da linha (0–1). Default 0.04. */
  opacity?: number;
  /** Cor RGB das listras (formato "r, g, b"). Default cinza-azulado "50, 63, 79". */
  color?: string;
}

/**
 * Linhas verticais sutis de fundo — pattern visto no allugatorinvest.com.
 * Use como overlay absoluto dentro de uma <section> com `relative overflow-hidden`.
 */
export const GridPattern = ({
  className,
  gap = 90,
  opacity = 0.04,
  color = "50, 63, 79",
}: GridPatternProps) => {
  return (
    <div
      aria-hidden
      className={cn("absolute inset-0 pointer-events-none", className)}
      style={{
        backgroundImage: `repeating-linear-gradient(to right, rgba(${color}, ${opacity}) 0, rgba(${color}, ${opacity}) 1px, transparent 1px, transparent ${gap}px)`,
        maskImage:
          "linear-gradient(to bottom, transparent 0%, rgba(0,0,0,1) 12%, rgba(0,0,0,1) 88%, transparent 100%)",
        WebkitMaskImage:
          "linear-gradient(to bottom, transparent 0%, rgba(0,0,0,1) 12%, rgba(0,0,0,1) 88%, transparent 100%)",
      }}
    />
  );
};
